import EventBus from '@vertx/eventbus-bridge-client.js'

var eb = new EventBus('https://apiss.ardkon.com/eventbus?basics=axb');


export default eb 